module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-ok-336061476bc0ac4e7d3d593a3d506d55.png";